// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"IdentityVerificationModal--buttonWrapper--ef95ea","identityVerificationModalBody":"IdentityVerificationModal--identityVerificationModalBody--432834"};